import React from 'react';
import PropTypes from 'prop-types';
import application_contants from '../../contants/application_contants';


export default function FooterHack4TTS({ section_id }) {
  return (
    <footer id={section_id} className="footer-hack4tts">
      {/* Top nav + logo */}
     <div className="footer-logo h1-medium section-title title-navy-blue pb-2 title">Voice Tech for All </div>
      {/* <div className="footer-top">
        <nav className="footer-nav">
          {['about','problem-statement','timeline','participate','evaluation','resources','faqs'].map(link => (
            <a key={link} href={`#${link}`}>{link.replace(/-/g,' ').replace(/\b\w/g,c=>c.toUpperCase())}</a>
          ))}
        </nav>
      </div> */}

      {/* Divider */}
      <hr className="footer-divider" />
      {/* Partner logos */}
      <div className="footer-partners">
        <img src={application_contants.iisclogo }      alt="IISc"      />
        <img src={application_contants.artparklogo }   alt="Artpark"   />
        <img src={application_contants.bhashinilogo } alt="Bhashini" />
        <img src={application_contants.gizlogo }       alt="GIZ"       />
        <img src={application_contants.spirelogo } alt="Spire Lab" />
        <img src={application_contants.armmanlogo }   alt="Armman"   />
      </div>

      {/* Divider */}   
      <hr className="footer-divider" />

      {/* Bottom line */}
      {/* <div className="footer-bottom">
        <span>© {new Date().getFullYear()} Hacks4TTS. All rights reserved.</span>
        <div className="footer-legal">
          <a href="/terms">Terms</a>
          <a href="/privacy">Privacy</a>
          <a href="/cookies">Cookies</a>
        </div>
      </div> */}
    </footer>
  )
}

FooterHack4TTS.propTypes = {
  section_id: PropTypes.string.isRequired
}
